import { useRecoilState, useRecoilValue } from 'recoil'
import navigationAtom from '../../navigation.atom'
import navCss from '../../navigation.module.css'
import sandboxAtom from '../../../Sandbox/sandbox.atom'
import { memo, useMemo } from 'react'
import LevelTile from './LevelTile'
import css from './levelNavigation.module.css'
import { ReactComponent as PlusIcon } from '../../../../asserts/icons/plus.svg'
import useHttpLoader from '../../../../hooks/useHttpLoader'
import Loader from '../../../../shared/Loaders/CircleLoader'
import tasksService from '../../../../services/tasks/tasks.service'
import useNavigationActions from '../../useNavigationActions'

const LevelNavigation = () => {
  const { wait, loading } = useHttpLoader()
  const { star } = useRecoilValue(navigationAtom)
  const [sandboxState, setSandboxState] = useRecoilState(sandboxAtom)
  const { toLevel } = useNavigationActions()
  const { level } = useRecoilValue(navigationAtom)

  const starTasks = useMemo(() => {
    return sandboxState.tasks.filter((t) => t.group === star)
  }, [star, sandboxState.tasks])

  const renderLevels = () => {
    return starTasks
      .filter((t) => t.type !== 8 && t.type !== 16)
      .map((t, index) => <LevelTile level={t} index={index} key={t.id} />)
  }

  const handleCreateIntro = () => {
    if (loading) return

    wait(tasksService.createEmptyTask(star, 8, { orderingIndex: 0 }), (resp) => {
      const index = sandboxState.tasks.findIndex((t) => t.group === star)

      setSandboxState((prev) => ({
        ...prev,
        tasks: [...prev.tasks.slice(0, index), resp, ...prev.tasks.slice(index)],
      }))
    })
  }

  const renderInscriptionLevel = () => {
    const introTask = starTasks.find((t) => t.type === 8 || t.type === 16)
    if (introTask)
      return (
        <div
          className={css.intoLevel}
          style={{ textAlign: 'center' }}
          onClick={() => toLevel(introTask.id)}
          data-selected={level === introTask.id}
        >
          0<br />
          Интро
        </div>
      )

    if (loading) {
      return (
        <div className={css.intoLevel}>
          <Loader className={css.plus} />
        </div>
      )
    }

    return (
      <div className={css.intoLevel} onClick={handleCreateIntro}>
        <PlusIcon className={css.plus} />
        <span>Интро</span>
      </div>
    )
  }

  return (
    <div className={navCss.horizontalScroll}>
      {renderInscriptionLevel()}
      {renderLevels()}
    </div>
  )
}

export default memo(LevelNavigation)
